import React from 'react';
import './ImageStyleSheet.css';

function uml5() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/umass5.jpeg" className='img-view'/>
        </div>
    )
}

export default uml5
